/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export function loadRelatedStories(story, config) {
  const { mountAt } = config || {};
  const mountAtPrefix = mountAt || "";
  const FIELDS =
    "id,metadata,story-template,headline,slug,hero-image-s3-key,hero-image-metadata,author-name,author-id,authors,url,alternative,last-published-at,first-published-at,hero-image-caption";
  const sectionQuery = story.sections && story.sections.length !== 0 ? `section-id=${story.sections[0].id}` : "";
  return fetch(`${mountAtPrefix}/api/v1/stories/${story.id}/related-stories?${sectionQuery}&fields=${FIELDS}`)
    .then((relatedStories) => relatedStories.json())
    .then((relatedStories) => relatedStories["related-stories"])
    .catch((err) => {
      console.error("Error in retrieving related stories :", err);
      return [];
    });
}
